import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class ChannelWisePermissionService {
    constructor(private http: HttpClient) {}

    addChannelPermission(data){
        return this.http.post<any>( `${environment.appOrgUrl}UserProfileConfiguration`, data);
    }

    editChannelPermission(data){
        return this.http.put<any>( `${environment.appOrgUrl}UserProfileConfiguration`, data);
    }

    makeDefaultPermission(userId, UserProfileConfigurationId){
        return this.http.get<any>( `${environment.appOrgUrl}UserProfileConfiguration/Default/${userId}/${UserProfileConfigurationId}`);
    }

    deleteChannelPermission(UserProfileConfigurationId){
        return this.http.delete<any>( `${environment.appOrgUrl}UserProfileConfiguration/${UserProfileConfigurationId}`);
    }

}